import { render, staticRenderFns } from "./IframeTemplateSpine.vue?vue&type=template&id=64222720&scoped=true&"
import script from "./IframeTemplateSpine.vue?vue&type=script&lang=js&"
export * from "./IframeTemplateSpine.vue?vue&type=script&lang=js&"
import style0 from "./IframeTemplateSpine.vue?vue&type=style&index=0&id=64222720&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64222720",
  null
  
)

export default component.exports